<mat-label class="date-label">{{ dateLabel }}</mat-label>
<mat-form-field appearance="fill" floatLabel="auto" class="date-range-field">
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate [(ngModel)]="startDate" [placeholder]="startDatePlaceholder" />
    <input matEndDate [(ngModel)]="endDate" [placeholder]="endDatePlaceholder" />
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker #picker [dateClass]="dateClass">
    <mat-date-range-picker-actions>
      <!-- Color Legend for Contractor Leave Application -->
      <div class="picker-legend" *ngIf="cardComponent === 'LEAVE_APPLICATION'">
        <div class="legend-items">
          <div class="legend-item">
            <span class="legend-color public-holiday-legend"></span>
            <span class="legend-text">Public Holiday</span>
          </div>
          <div class="legend-item">
            <span class="legend-color paid-leave-legend"></span>
            <span class="legend-text">Paid Leave</span>
          </div>
          <div class="legend-item">
            <span class="legend-color unpaid-leave-legend"></span>
            <span class="legend-text">Unpaid Leave</span>
          </div>
          <div class="legend-item">
            <span class="legend-color half-paid-legend"></span>
            <span class="legend-text">Half Paid Leave</span>
          </div>
          <div class="legend-item">
            <span class="legend-color half-unpaid-legend"></span>
            <span class="legend-text">Half Unpaid Leave</span>
          </div>
          <div class="legend-item" *ngIf="billableDates && billableDates.length > 0">
            <span class="legend-color last-working-day"></span>
            <span class="legend-text">Billable Hours</span>
          </div>
        </div>
      </div>
      
      <div class="button-container">
        <button mat-button matDateRangePickerCancel (click)="onCancel()">
          Cancel
        </button>
        <button
          class="applyButton"
          mat-raised-button
          color="primary"
          (click)="onDateChange()"
          matDateRangePickerApply
        >
          Apply
        </button>
      </div>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>